import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { STATIC_STRINGS } from "@asez/shared";
import {
  leftCellSx,
  middleCellSx,
  questionTypeSx,
  rightCellSx,
  rowSx,
} from "./tableStyles";

const headerCells = [
  {
    label: STATIC_STRINGS.TOPIC,
    sx: leftCellSx,
  },
  {
    label: STATIC_STRINGS.QUESTION_TYPE,
    sx: questionTypeSx,
  },
  {
    label: STATIC_STRINGS.DIFFICULTY_LEVEL,
    sx: middleCellSx,
  },
  {
    label: STATIC_STRINGS.NUMBER_OF_QUESTIONS,
    sx: middleCellSx,
  },
  {
    label: STATIC_STRINGS.ADDITIONAL_REQUIREMENTS,
    sx: middleCellSx,
  },
  {
    label: STATIC_STRINGS.TABLE_HEADERS.ACTIONS,
    sx: rightCellSx,
  },
];

const TableHeader = () => {
  return (
    <TableHead
      sx={{
        backgroundColor: "var(--color-table-header)",
        "& .MuiTableCell-head": {
          backgroundColor: "var(--color-table-header)",
        },
        position: "sticky",
        top: "0px",
        zIndex: 20,
      }}
    >
      <TableRow sx={rowSx}>
        {headerCells.map(({ label, sx }) => (
          <TableCell
            key={label}
            align="center"
            sx={{ ...sx, fontWeight: "bold" }}
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
